module.exports = __webpack_public_path__ + "static/images/styles/images/reserves/rewards/additional-briefing-reward-50.73d462e9.png";


//////////////////
// WEBPACK FOOTER
// ./styles/images/reserves/rewards/additional-briefing-reward-50.png
// module id = 3769
// module chunks = 11